export default __webpack_public_path__ + "static/media/rearive.218eda08.png";